<template>
  <v-container class="pa-5 bg" fluid v-editable="blok">
    <v-row>
      <v-container fluid>
        <v-row justify="center" align="center">
          <v-col cols="12" sm="10" md="10" lg="8">
            <v-card tile flat class="card pa-5 mt-5">
              <v-form ref="form" v-model="formValid">
                <v-containner>
                  <v-row>
                    <v-col cols="12">
                      <div class="title mb-5 text-center">
                        <div class="pb-icon">
                          <figure>
                            <img src="@/assets/logo_mini_dark.svg" alt />
                          </figure>
                          <div class="before">
                            <span>►</span>
                          </div>
                        </div>
                        <h2>{{blok.title}}</h2>
                        <div class="pb-icon">
                          <div class="after">
                            <span>◄</span>
                          </div>
                          <figure>
                            <img src="@/assets/logo_mini_dark.svg" alt />
                          </figure>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        filled
                        v-model="form.name"
                        :rules="blok.lenguage == 'es' ? formRules.text : formRulesEn.text"
                        :counter="60"
                        :label="blok.lenguage == 'es' ? 'Nombre' : 'Name'"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        filled
                        v-model="form.phone"
                        :rules="blok.lenguage == 'es' ? formRules.numbers : formRulesEn.numbers"
                        :counter="15"
                        :label="blok.lenguage == 'es' ? 'Teléfono' : 'Phone'"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        filled
                        v-model="form.email"
                        :rules="blok.lenguage == 'es' ? formRules.email : formRulesEn.email"
                        :counter="60"
                        :label="blok.lenguage == 'es' ? 'Correo' : 'Email'"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        filled
                        v-model="form.industry"
                        :rules="blok.lenguage == 'es' ? formRules.text : formRulesEn.text"
                        :counter="60"
                        :label="blok.lenguage == 'es' ? 'Industria' : 'Industry'"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        filled
                        v-model="form.comment"
                        :rules="blok.lenguage == 'es' ? formRules.text : formRulesEn.text"
                        :counter="360"
                        :label="blok.lenguage == 'es' ? 'Cuéntanos con que te podemos ayudar' : 'Tell us what we can help you with'"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" justify="center" align="center">
                      <v-btn
                        color="accent"
                        tile
                        depressed
                        x-large
                        @click="submit()"
                        :loading="loading"
                        :disabled="loading || !formValid"
                      >{{blok.lenguage == 'es' ? 'Enviar' : 'Send'}}</v-btn>
                    </v-col>
                  </v-row>
                </v-containner>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-snackbar
      v-model="formError.state"
      :multi-line="true"
      :timeout="formError.timeout"
      :color="formError.color"
      :top="true"
    >
      {{ formError.msg }}
      <v-btn color="white" text @click="formError.state = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import { formValidation } from "@/libs/formValidation";
export default {
  mixins: [formValidation],
  data() {
    return {
      form: {
        name: null,
        phone: null,
        email: null,
        industry: null,
        comment: null
      },
      loading: false
    };
  },
  methods: {
    submit() {
      if (this.formValid) {
        this.loading = true;
        const contactFire = firebase.functions().httpsCallable("contact");
        contactFire(this.form)
          .then(() => {
            this.loading = false;
            if (this.blok.lenguage == "es") {
              this.alertError("success", "Envío exitoso");
            } else {
              this.alertError("success", "Message sent successfully");
            }
            this.$refs.form.reset();
          })
          .catch(() => {
            this.loading = false;
            if (this.blok.lenguage == "es") {
              this.alertError("error", "Hubo un error, intenta nuevamente");
            } else {
              this.alertError("error", "There is an error, please try again");
            }
            this.$refs.form.reset();
          });
      }
    }
  },
  props: ["blok"]
};
</script>

<style lang="scss" scoped>
@import "./ContactForm.scss";
</style>